export function validateMultiplesFormData (formData, names) {
  const DOUBLE_NUMBER = 1;
  names.forEach((name)=> {
    if(formData.getAll(name).length > DOUBLE_NUMBER){
      const lastValue = formData.getAll(name).pop();
      formData.delete(name);
      formData.append(name, lastValue)
    }
  })
  return formData;
}
